import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;

// Async menu generation: starts a background job and polls until done.
export async function startAndPollMenu(body, { fromInventory = false } = {}) {
  const { data } = await api.post("/menus/generate/start", { ...body, from_inventory: fromInventory });
  if (data.menu) return data.menu; // demo / instant
  return pollMenuJob(data.job_id);
}

// Import a chef's own recipe/menu (multipart: file and/or text) and poll until structured.
export async function startAndPollImport(formData) {
  const { data } = await api.post("/menus/import/start", formData, { headers: { "Content-Type": "multipart/form-data" } });
  return pollMenuJob(data.job_id);
}

async function pollMenuJob(jobId) {
  for (let i = 0; i < 100; i++) {
    await new Promise((r) => setTimeout(r, 3000));
    let s;
    try {
      ({ data: s } = await api.get(`/menus/jobs/${jobId}`));
    } catch { continue; }
    if (s.status === "done") return s.menu;
    if (s.status === "error") throw new Error(s.error || "This is taking longer than expected. Please try again.");
  }
  throw new Error("This is taking longer than expected. Please try again.");
}
